import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    APP_CONFIG_FEATURE_KEY,
    AppConfigState,
    AppConfigValuesState,
    LocationTrackerAdminConfigState,
} from '../app-config.state';

export const selectAppConfigFeature = createFeatureSelector<AppConfigState>(APP_CONFIG_FEATURE_KEY);

/** Raw load status of the slice — drives the settle-wait in `awaitAppConfigSettled`. */
export const selectAppConfigStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectAppConfigFeature,
    (state) => state.status,
);

/** Whether the backend GET has succeeded. Used to guard the hydrate effects against a stale cache read. */
export const selectAppConfigLoaded: MemoizedSelector<object, boolean> = createSelector(
    selectAppConfigStatus,
    (status) => status === LoadStatus.Loaded,
);

/** The persisted projection — the config values without the load lifecycle. */
export const selectAppConfigValues: MemoizedSelector<object, AppConfigValuesState> = createSelector(
    selectAppConfigFeature,
    (state) => state.values,
);

/** Replaces `AppConfigService.locationTracker$`. `undefined` when the module was never configured. */
export const selectLocationTrackerAdminConfig: MemoizedSelector<object, LocationTrackerAdminConfigState | undefined> =
    createSelector(selectAppConfigValues, (values) => values.locationTracker);

/** Replaces `AppConfigService.isLocationTrackerEnabled$`'s `?.Enabled ?? false` fallback. */
export const selectIsLocationTrackerEnabled: MemoizedSelector<object, boolean> = createSelector(
    selectLocationTrackerAdminConfig,
    (locationTracker) => locationTracker?.enabled ?? false,
);
